export default __webpack_public_path__ + "static/media/scanbat.6120b4b7.png";